// src/contexts/BreadcrumbsContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';

const BreadcrumbsContext = createContext();

export const BreadcrumbsProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [idMappings, setIdMappings] = useState({});

  const updateBreadcrumb = useCallback((index, name) => {
    setBreadcrumbs((prev) => {
      const newBreadcrumbs = [...prev];
      newBreadcrumbs[index] = { ...newBreadcrumbs[index], name };
      return newBreadcrumbs;
    });
  }, []);

  const updateLastBreadcrumb = useCallback((name) => {
    setBreadcrumbs((prev) => {
      const newBreadcrumbs = [...prev];
      newBreadcrumbs[newBreadcrumbs.length - 1] = { ...newBreadcrumbs[newBreadcrumbs.length - 1], name };
      return newBreadcrumbs;
    });
  }, []);

  // Fonction pour enregistrer un mapping ID → nom
  const registerIdMapping = useCallback((id, name, type = 'default') => {
    setIdMappings((prev) => {
      // Éviter les mises à jour inutiles si le mapping existe déjà
      if (prev[id]?.name === name) {
        return prev;
      }
      return {
        ...prev,
        [id]: { name, type }
      };
    });
  }, []);

  // Fonction pour obtenir le nom d'un ID
  const getNameForId = useCallback((id) => {
    return idMappings[id]?.name || id;
  }, [idMappings]);

  // Fonction pour nettoyer les mappings (optionnel, pour éviter l'accumulation)
  const clearIdMappings = useCallback(() => {
    setIdMappings({});
  }, []);

  
  return (
    <BreadcrumbsContext.Provider value={{ 
      breadcrumbs, 
      setBreadcrumbs, 
      updateBreadcrumb, 
      updateLastBreadcrumb,
      registerIdMapping,
      getNameForId,
      clearIdMappings,
      idMappings
    }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbsContext);
